import { Field, Form, Formik } from 'formik'
import React from 'react'

import {
  Button,
  ButtonGroup,
  CurrencyInput,
  ModalBox,
  useModalContext,
} from '@fourthwall/components'

import * as S from './styled'
import type {
  SizeVariantSellingPriceModalFormValues,
  SizeVariantSellingPriceModalProps,
} from './types'
import { validationSchema } from './validationSchema'

export const SizeVariantSellingPriceModal = ({
  offerVariant,
  onSubmit,
  isCompareAtPriceEnabled,
}: SizeVariantSellingPriceModalProps) => {
  const { close } = useModalContext()

  const handleOnSubmit = (values: SizeVariantSellingPriceModalFormValues) => {
    onSubmit(values)
    close()
  }

  return (
    <ModalBox title={`Edit ${offerVariant.size} selling price`} onClose={close}>
      <Formik<SizeVariantSellingPriceModalFormValues>
        initialValues={{
          price: offerVariant.price,
          compareAtPrice: offerVariant.compareAtPrice,
        }}
        validationSchema={validationSchema}
        onSubmit={handleOnSubmit}
      >
        {() => (
          <Form>
            <S.Container>
              <S.Content>
                <Field
                  component={CurrencyInput}
                  label="Selling price"
                  name="price.value"
                  type="number"
                  size="large"
                  hideSpinner
                />

                {isCompareAtPriceEnabled && (
                  <Field
                    name="compareAtPrice.value"
                    label="Compare-at price (optional)"
                    component={CurrencyInput}
                    type="number"
                    size="large"
                    strikethrough
                  />
                )}
              </S.Content>
              <ButtonGroup direction="column" fullWidth space="medium">
                <Button type="submit" appearance="primary" label="Update" fullWidth />
                <Button appearance="secondary" label="Cancel" fullWidth onClick={close} />
              </ButtonGroup>
            </S.Container>
          </Form>
        )}
      </Formik>
    </ModalBox>
  )
}
